import cx from "classnames";
import { type FC } from "react";

import { AvatarGroup } from "../AvatarGroup";
import { AvatarSize, AvatarType, MomentAvatar } from "../MomentAvatar";
import { type ButtonSize } from "../MomentButton";
import { type ReactionUser } from "./ReactionUser";
import {
	ENSURE_BUTTON_HEIGHT,
	avatarGroupWidth,
	positionOverflowAvatarsAbsoluteRight0,
	slideFirstUserInOnReaction,
} from "./styles";
import { useReactionsSummary } from "./useReactionsSummary";

export const ReactionAvatarGroup: FC<{
	size: ButtonSize;
	currentUser?: ReactionUser;
	reactions: ReactionUser[];
}> = ({ size, currentUser, reactions }) => {
	const avatarSize = AvatarSize.xxs;
	const anyUserVoted = reactions.length > 0;

	const { currentUserReacted, visibleReactions, overflowReactions, avatarGroupSize } =
		useReactionsSummary(reactions, currentUser);

	return (
		<AvatarGroup
			className={cx(
				"flex",
				"transition-all",
				avatarGroupWidth(reactions),
				slideFirstUserInOnReaction(!currentUser || currentUserReacted),
				positionOverflowAvatarsAbsoluteRight0(overflowReactions),
				ENSURE_BUTTON_HEIGHT[size],
				{
					"-ml-2 opacity-0 duration-0": !anyUserVoted,
					"ml-0 opacity-100 duration-200": anyUserVoted,
				}
			)}
			avatarSize={avatarSize}
			max={avatarGroupSize}
		>
			{currentUser && (
				<MomentAvatar
					userName={currentUser.name}
					avatarType={AvatarType.Image}
					size={avatarSize}
					imageURL={currentUser.profilePicture}
				/>
			)}
			{visibleReactions.length > 0 &&
				visibleReactions.map((reaction) => (
					<MomentAvatar
						key={reaction.id}
						userName={reaction.name}
						avatarType={AvatarType.Image}
						size={avatarSize}
						imageURL={reaction.profilePicture}
					/>
				))}
			{overflowReactions.map((reaction) => {
				return (
					<MomentAvatar
						key={reaction.id}
						userName={reaction.name}
						avatarType={AvatarType.Image}
						size={avatarSize}
						imageURL={reaction.profilePicture}
					/>
				);
			})}
		</AvatarGroup>
	);
};
